import { GET_MY } from '../../containers/App/constants';
import { IDW_ADDRESSES, REQUEST_ADDRESS, REQUEST_ADDRESS_TYPES, REQUEST_ADDRESSES_BY_IDS } from './constants';

export function fetchAddressTypes() {
  return {
    type: GET_MY,
    id: REQUEST_ADDRESS_TYPES,
    work: REQUEST_ADDRESS_TYPES,
    path: 'customer/address-types',
  };
}

export function fetchAddress(addressId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADDRESS,
    addressId,
    gate: `${REQUEST_ADDRESS}-${addressId}`,
    work: `${REQUEST_ADDRESS}-${addressId}`,
    path: `addresses/${addressId}`,
    callback,
  };
}

export function fetchAddressesByIds(addressIds = [], callback) {
  const ids = addressIds.filter(id => !IDW_ADDRESSES.find(a => a.id === id));
  return {
    type: GET_MY,
    id: REQUEST_ADDRESSES_BY_IDS,
    addressIds,
    gate: `${REQUEST_ADDRESSES_BY_IDS}-${addressIds.join('_')}`,
    work: `${REQUEST_ADDRESSES_BY_IDS}`,
    path: `addresses/by-ids`,
    post: { ids },
    callback,
  };
}
